import { Flex, Switch } from "@theorgchartdev/storybook";
import { FieldInputLabel } from "@/appComponents/Blocks/Composites/FieldInputLabel";
import { TabProps } from "./DocumentExportContent";
import { appstr } from "@coreapp/utils/appstr";
import { usePermissionCheck } from "@/hooks/usePermissionCheck";

export const DocumentExportAdvanced = (props: TabProps) => {
  const { fieldData, onFieldChange } = props.formController;
  const { showFunctionalStatement } = usePermissionCheck();

  const disableIndex = fieldData.scope !== "Book";
  const disableFunctionalStatements = fieldData.scope !== "Book";

  return (
    <Flex direction="column" gap="12px" padding="6px 24px 0">
      <FieldInputLabel
        id="document-export-navigation-arrows-switch"
        label={appstr("Dynamic Navigation")}
        helper={appstr(
          "Include clickable navigation arrows connecting pages of the chart. May not be useful when physically printing"
        )}
      >
        <Switch
          id="document-export-navigation-arrows-switch"
          onChange={nextChecked => onFieldChange("navigationArrows", nextChecked)}
          checked={fieldData.navigationArrows}
        />
      </FieldInputLabel>
      <FieldInputLabel
        id="document-export-index-page-switch"
        label={appstr("Index Page")}
        helper={appstr("Include a page at the end of the export with name and number")}
        labelInfo={disableIndex ? appstr("disableIndexSwitch") : undefined}
      >
        <Switch
          id="document-export-index-page-switch"
          onChange={nextChecked => onFieldChange("indexPage", nextChecked)}
          checked={fieldData.indexPage}
          disabled={disableIndex}
        />
      </FieldInputLabel>
      <FieldInputLabel
        id="document-export-uniform-scaling-switch"
        label={appstr("Uniform Scaling")}
        helper={appstr(
          "Ensure all boxes on each page are identically sized. This generally means boxes will be smaller than usual to accomodate large pages"
        )}
      >
        <Switch
          id="document-export-uniform-scaling-switch"
          onChange={nextChecked => onFieldChange("uniformScaling", nextChecked)}
          checked={fieldData.uniformScaling}
        />
      </FieldInputLabel>
      <FieldInputLabel
        id="document-export-includefilteredmgrs-switch"
        label={appstr("includefiltered")}
        helper={appstr("includefilteredhelper")}
      >
        <Switch
          id="document-export-includefilteredmgrs-switch"
          onChange={nextChecked => onFieldChange("includefilteredmgrs", nextChecked)}
          checked={fieldData.includefilteredmgrs}
        />
      </FieldInputLabel>
      {showFunctionalStatement && (
        <FieldInputLabel
          id="document-export-functional-statements-switch"
          label={appstr("Include Functional Statements")}
          helper={appstr("includeFunctionalStatementsHelper")}
          labelInfo={
            disableFunctionalStatements ? appstr("disableFunctionalStatementsSwitch") : undefined
          }
        >
          <Switch
            id="document-export-functional-statements-switch"
            onChange={nextChecked => onFieldChange("functionStatements", nextChecked)}
            checked={fieldData.functionStatements}
            disabled={disableFunctionalStatements}
          />
        </FieldInputLabel>
      )}
    </Flex>
  );
};
